// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3yuZC","disabled":"FileBtn_disabled__1U-nc","warn":"FileBtn_warn__2xvM-","fade":"FileBtn_fade__2EEL4"};